import { calculateSalaryTaxParams } from "./types";
import { laws } from "@/data-source";
import { Bracket } from "@/data-source/types";
import { calculateTax, isSupported } from "@/helpers/utils";
import { LawYear } from "@/types/salary";

const calculateYearlySalaryTax = (lawYear: LawYear, yearlySalary: number) => {
    if (yearlySalary <= 0) return 0;

    const taxBracket = laws[lawYear].brackets.find(
        (item: Bracket): Bracket | boolean => {
            return isSupported(item, yearlySalary) ? item : false;
        }
    ) as Bracket;

    return calculateTax(taxBracket, yearlySalary);
};

const calculateSalaryTax = ({
    grossSalary,
    socialInsuranceWorkerShare,
    lawYear,
}: calculateSalaryTaxParams) => {
    if (!laws[lawYear]) throw new RangeError("Unsupported law year");
    if (
        ![grossSalary, socialInsuranceWorkerShare].every(
            (value) => Number.isFinite(value) && value >= 0
        )
    )
        throw new RangeError(
            "Salary and worker insurance share must be finite and nonnegative"
        );

    // Annualize before subtracting the annual exemption to avoid cancellation
    // errors at exact tax boundaries, then round down as required by Article 8.
    const annualIncome =
        (grossSalary - socialInsuranceWorkerShare) * 12 -
        laws[lawYear].exemptionThreshold;
    const scaledIncome = annualIncome / 10;
    const yearlySalary =
        Math.floor(scaledIncome + Number.EPSILON * Math.abs(scaledIncome) * 4) *
        10;

    const yearlySalaryTax = calculateYearlySalaryTax(lawYear, yearlySalary);

    return yearlySalaryTax / 12;
};

export { calculateSalaryTax };
